import {clientRecords} from '@atheneum/api'
import { extendObservable } from 'mobx'
import omitBy from 'lodash/omitBy'

class ProjectsListingStore {
  constructor () {
    extendObservable(this, {
      loading: null,
      error: null,
      total: null,
      accountSuggestion: { value: 0, label: 'All' },
      query: this.getEmptyQuery(),
      projects: []
    })
  }

  getEmptyQuery () {
    return {
      statusIds: [],
      parentAccountId: null,
      accountId: null,
      officeId: null,
      page: 1
    }
  }

  filter = (page = 1) => {
    this.loading = true
    this.error = null
    this.total = null

    const query = {
      ...omitBy(this.query, propValue => propValue == null),
      page
    }

    clientRecords
      .getProjects(query)
      .then(({ hits }) => {
        this.total = hits.total
        const projects = hits.hits.map(hit => {
          return hit._source
        })
        this.projects.replace(projects)
        this.query.page = page
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }
}

export default ProjectsListingStore
